import { BaseRequest } from "../../../../base/request/BaseRequest";

/** Request del paso 1 de recuperación de contraseña: pide el envío del código
 *  OTP al email indicado. El endpoint responde 200 exista o no la cuenta (el
 *  servidor no revela qué emails están registrados). */
export type OlvidePasswordRequest = BaseRequest & {
  /** Email de la cuenta a recuperar. */
  email: string;
};

export const fx_createOlvidePasswordRequest = (
  email: string = "",
): OlvidePasswordRequest => {
  return {
    email,
  };
};
